import { render, staticRenderFns } from "./FormItemRating.vue?vue&type=template&id=60f7ab87"
import script from "./FormItemRating.vue?vue&type=script&lang=js"
export * from "./FormItemRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports